import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface UserSatisfactionProps
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
}

export const UserSatisfaction = forwardRef<
  HTMLDivElement,
  UserSatisfactionProps
>(({ content, className, ...rest }, ref) => (
  <div
    ref={ref}
    className={classNames(
      "wb-flex wb-flex-row wb-items-center wb-gap-4 wb-text-primary wb-mx-auto md:wb-mx-0",
      className,
    )}
    {...rest}
  >
    <div className="wb-flex wb-flex-col md:wb-flex-row wb-items-center wb-gap-4">
      {content}
    </div>
  </div>
));

UserSatisfaction.displayName = "UserSatisfaction";
